import RecentSearchesList from './RecentSearchesList.component';

export default RecentSearchesList;
